//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { PINNED_MEDIA_TOOLBAR_ACTIONS } from '@galleries/constants/galleriesConstants';
import { PinnedMediaToolbarContext } from '@galleries/models/pinnedMediaToolbarModel';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';
import gaApi from 'app/initialization/ga/ga-api';

const openToolbar = (context: PinnedMediaToolbarContext) =>
  createAction({
    type: PINNED_MEDIA_TOOLBAR_ACTIONS.OPEN_TOOLBAR,
    context,
  });

const closeToolbar = (context: PinnedMediaToolbarContext) =>
  createAction({
    type: PINNED_MEDIA_TOOLBAR_ACTIONS.CLOSE_TOOLBAR,
    context,
  });

export type PinnedMediaToolbarAction = ReturnType<
  typeof openToolbar | typeof closeToolbar
>;

export const pinnedMediaToolbarActions = {
  openToolbar: (context: PinnedMediaToolbarContext) => (
    dispatch: ReduxDispatch,
  ) => {
    dispatch(openToolbar(context));

    switch (context) {
      case PinnedMediaToolbarContext.PREVIEW_GALLLERY_MODAL: {
        gaApi.recordEvent(
          gaApi.CATEGORY_GALLERIES,
          gaApi.ACTION_PINNED_MEDIA_GALLERY_PREVIEW_SHOW,
          gaApi.LABEL_TOUCHPOINTS_GALLERIES,
        );
        break;
      }
      case PinnedMediaToolbarContext.GALLERIES_DASHBOARD: {
        gaApi.recordEvent(
          gaApi.CATEGORY_GALLERIES,
          gaApi.ACTION_PINNED_MEDIA_SHOW_PINNED_MEDIA,
          gaApi.LABEL_TOUCHPOINTS_GALLERIES,
        );
        break;
      }
    }
  },

  closeToolbar: (context: PinnedMediaToolbarContext) => (
    dispatch: ReduxDispatch,
  ) => {
    dispatch(closeToolbar(context));

    switch (context) {
      case PinnedMediaToolbarContext.PREVIEW_GALLLERY_MODAL: {
        gaApi.recordEvent(
          gaApi.CATEGORY_GALLERIES,
          gaApi.ACTION_PINNED_MEDIA_GALLERY_PREVIEW_HIDE,
          gaApi.LABEL_TOUCHPOINTS_GALLERIES,
        );
        break;
      }
      case PinnedMediaToolbarContext.GALLERIES_DASHBOARD: {
        gaApi.recordEvent(
          gaApi.CATEGORY_GALLERIES,
          gaApi.ACTION_PINNED_MEDIA_HIDE_PINNED_MEDIA,
          gaApi.LABEL_TOUCHPOINTS_GALLERIES,
        );
        break;
      }
    }
  },
};
